module.exports = __webpack_public_path__ + "media/images/joinit-9926dabbe4039ce155ca09344da9d9a2.png";